// @flow
import React from "react";
import nerd from "../../static/emoji/1f913.svg";
import blush from "../../static/emoji/1f60a.svg";
import persevere from "../../static/emoji/1f623.svg";
import scream_cat from "../../static/emoji/1f640.svg";
import clap from "../../static/emoji/1f44f.svg";
import crown from "../../static/emoji/1f451.svg";
import confetti_ball from "../../static/emoji/1f38a.svg";
import thumbsup from "../../static/emoji/1f44d.svg";
import mortar_board from "../../static/emoji/1f393.svg";
import tada from "../../static/emoji/1f389.svg";
import wave from "../../static/emoji/1f44b.svg";
import carrot from "../../static/emoji/1f955.svg";
import third_place from "../../static/emoji/1f949.svg";

const emojis = {
  nerd: {
    src: nerd,
    name: "nerd face"
  },
  blush: {
    src: blush,
    name: "smiling face with smiling eyes"
  },
  persevere: {
    src: persevere,
    name: "persevering face"
  },
  scream_cat: {
    src: scream_cat,
    name: "weary cat face"
  },
  clap: { src: clap, name: "clap" },
  crown: { src: crown, name: "crown" },
  confetti_ball: { src: confetti_ball, name: "confetti ball" },
  thumbsup: { src: thumbsup, name: "thumbs up sign" },
  mortar_board: { src: mortar_board, name: "graduation cap" },
  tada: { src: tada, name: "party popper" },
  wave: { src: wave, name: "wave sign" },
  carrot: { src: carrot, name: "carrot" },
  third_place: { src: third_place, name: "third place medal" }
};

type Props = {
  name:
    | "nerd"
    | "blush"
    | "persevere"
    | "scream_cat"
    | "clap"
    | "crown"
    | "confetti_ball"
    | "thumbsup"
    | "mortar_board"
    | "tada"
    | "wave"
    | "carrot"
    | "third_place"
};

const Emoji = ({ name }: Props) => {
  const emoji = emojis[name];

  return emoji
    ? <span>
        <img src={emojis[name].src} alt={`${emojis[name].name} emoji`} />
        <style jsx>{`
      img {
        display: inline-block;
        height: 24px;
        width: 24px;
        vertical-align: bottom;
      }
    `}</style>
      </span>
    : null;
};

export default Emoji;



// WEBPACK FOOTER //
// ./src/components/Quiz/Emoji.js